import { render, staticRenderFns } from "./paste-editor.vue?vue&type=template&id=62137086&"
import script from "./paste-editor.vue?vue&type=script&lang=js&"
export * from "./paste-editor.vue?vue&type=script&lang=js&"
import style0 from "./paste-editor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports